
import React, { Component, Fragment, useEffect, useState } from 'react';
import Datas from '../../../data/course/item.json';
import { Link } from 'react-router-dom';
import { Col } from 'react-bootstrap';
import Pagination from './../../../components/Pagination';
import Services, { URI } from '../../../services/service';
import { useHistory } from 'react-router-dom';
import UserService from '../../../services/UserService';
import { useSelector } from 'react-redux';
import ReactPaginate from "react-paginate";
import "../styles/pagination.css";
import ReactHtmlParser, { processNodes, convertNodeToElement, htmlparser2 } from 'react-html-parser';
import swal from 'sweetalert';
import CryptoJS from "crypto-js";
import { useTranslation } from 'react-i18next'
import cookies from 'js-cookie';
import { COURSE_URL, USER_API } from '../../../services/service';
import { Rating } from 'react-simple-star-rating';
import { Circles } from 'react-loader-spinner';

const languages = [

    {
        code: 'en',
        name: 'English',
        country_code: 'gb',
    },

    //{
    //     code: 'hi',
    //     name: 'Hindi',
    //     country_code: 'in'
    // },
    // {
    //     code: 'te',
    //     name: 'Telugu',
    //     country_code: 'in'
    // },
    // {
    //     code: 'pu',
    //     name: 'Punjabi',
    //     country_code: 'in'
    // },
    // {
    //     code : 'mr',
    //     name : 'Marathi',
    //     country_code : 'in'
    // }
]



const UserEnrolledCoursesList = (props) => {

    useEffect(() => {
        UserService.generateToken();
    }, []);


    useEffect(() => {
        UserService.generateToken();
    }, []);

    const currentLanguageCode = cookies.get('i18next') || 'en'
    const currentLanguage = languages.find((l) => l.code === currentLanguageCode)
    const { t } = useTranslation()
    useEffect(() => {
        document.body.dir = currentLanguage.dir || 'ltr'
        document.title = t('app_title')
    }, [currentLanguage, t])

    const um_api = URI.SERVER?._USER_API;



    const [loading, setLoading] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [getAvgRating, setAvgRating] = useState([]);
    const [postsPerPage] = useState(10);
    const [courseState, setCourseState] = useState([]);
    const [filteredCourse, setFilteredCourse] = useState([]);
    const [pageNumber, setPageNumber] = useState(0);
    const [paidJsonState, setPaidJsonState] = useState();
    const [freeJsonState, setFreeJsonState] = useState();
    const history = useHistory();
    let paidStat = useSelector(state => state.paidCourse);
    let freeStat = useSelector(state => state.freeCourse);
    let value = useSelector(state => state.inputValue);
    let categoryValue = useSelector(state => state.categoryValue);
    let searchEngine = useSelector(state => state.searchEngine);
    let dummyCategory = [];
    if (categoryValue) {
        dummyCategory = courseState.filter(function (ele) {
            return ele.catName == categoryValue;
        })

    }
    let userId = UserService.getUserid();
    let roleId = 1;
    useEffect(() => {
        const fetchPosts = async () => {
            setLoading(true);
            const res = await Services.getUserEnrolledCourses(userId, roleId);
            setCourseState(res.data);
            setPaidJsonState(res.data.filter(function (ele) {
                return ele.courseDetails.courseFee > 0;
            }));
            setFreeJsonState(res.data.filter(function (ele) {
                return ele.courseDetails.courseFee == 0;
            }));
            setLoading(false);
        };

        Services.averageRating()
            .then(res => {
                setAvgRating(res.data);
            })

        fetchPosts();
    }, []);

    const [searchEngineData, setsearchEngineData] = useState([]);
    const [getCourseIdsData, setCourseIdsData] = useState([]);
    let courseIds = [];
    let tenentId = [];
    let uniqueCourseIds;
    let tenids;
    // useEffect(() => {
    //     Services.searchEngine(searchEngine)
    //         .then(res => {
    //             let abc = res.data;
    //             setsearchEngineData(abc.hits.hits)
    //             searchEngineData.map((d) => {
    //                 var abc = `${d._source.path.real}`;
    //                 //for windows var str = abc.replace(/\\/g, '\\');
    //                 var str1 = abc.split('/');
    //                 courseIds.push(str1[9]);
    //                 tenentId.push(str1[7]);
    //                 uniqueCourseIds = [...new Set(courseIds)]
    //                 let uniqueTenantId = [...new Set(tenentId)]
    //                 var str2 = uniqueTenantId.toString();
    //                 tenids = str2.substring(6, 8);
    //                 Services.SearchEngineResult(uniqueCourseIds, tenids)
    //                     .then(res => {
    //                         setCourseIdsData(res.data)
    //                     })
    //             })
    //         }).catch(err => alert("Service is down please try after some time"));
    // }, [searchEngine])

    // Get current posts
    // const indexOfLastPost = currentPage * postsPerPage;
    // const indexOfFirstPost = indexOfLastPost - postsPerPage;
    let currentCourseState;
    if (value) {
        let data = courseState.filter((course) =>
            course.courseDetails.courseName.toLowerCase().includes(value)
        )
        currentCourseState = data.slice(0, 1000);
    }
    else if (categoryValue) {
        currentCourseState = dummyCategory.slice(0, 1000);
    }
    else if (paidStat) {
        if (paidJsonState == undefined) {
            currentCourseState = courseState.slice(0, 1000);
        } else {
            currentCourseState = paidJsonState.slice(0, 1000);
        }
    }
    else if (freeStat) {
        if (freeJsonState == undefined) {
            currentCourseState = courseState.slice(0, 1000);
        } else {
            currentCourseState = freeJsonState.slice(0, 1000);
        }
    }
    else if (searchEngine) {
        currentCourseState = getCourseIdsData.slice(0, 1000);
    }
    else {
        currentCourseState = courseState.slice(0, 1000);
    }
    //const currentCourseState = courseState.slice(indexOfFirstPost, indexOfLastPost);

    // Change page
    // const paginate = pageNumber => setCurrentPage(pageNumber);


    const usersPerPage = 9;
    const pagesVisited = pageNumber * usersPerPage;

    const pageCount = Math.ceil(currentCourseState.length / usersPerPage);

    const changePage = ({ selected }) => {
        setPageNumber(selected);
    };

    const cipher = salt => {
        const textToChars = text => text.split('').map(c => c.charCodeAt(0));
        const byteHex = n => ("0" + Number(n).toString(32)).substr(-2);
        const applySaltToChar = code => textToChars(salt).reduce((a, b) => a ^ b, code);
        return text => text.split('')
            .map(textToChars)
            .map(applySaltToChar)
            .map(byteHex)
            .join('');
    }

    const CourseDetails = (id, tid, status) => {
        
        const secretKey = "cdac@123"

        const encodedCourseId = CryptoJS.AES.encrypt(
            `${id}`,
            secretKey
        ).toString();
        const safeEncodedCourseId = encodedCourseId
            .replace(/\+/g, "-")
            .replace(/\//g, "_")
            .replace(/=+$/, "");

        const encodedTenantId = CryptoJS.AES.encrypt(
            `${tid}`,
            secretKey
        ).toString();
        const safeEncodedTenantId = encodedTenantId
            .replace(/\+/g, "-")
            .replace(/\//g, "_")
            .replace(/=+$/, "");

        history.push(`${process.env.PUBLIC_URL + "/course-details/"}${safeEncodedCourseId}/${safeEncodedTenantId}/${status}`);

    }

    let RESTRICTED = "Restricted"
    const fee_validator = (fees, courseType,foreignFees) => {
        if (courseType === "free") {
            return "Free Course"
        }
        else if (courseType === "paid") {
            return <div>&#8377;{fees} {foreignFees > 0 && <span> / &#0036;{foreignFees}</span>}</div>
        }
        else {
            return <div>{RESTRICTED}</div>
        }
    }

    if (loading) {
        return <div
            style={{
                position: 'fixed', // Ensures the div stays on top of other content
                top: 0,
                left: 0,
                width: '100vw', // Covers the entire viewport width
                height: '100vh', // Covers the entire viewport height
                backgroundColor: 'rgba(255, 255, 255, 0.562)', // Semi-transparent background
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center', // Centers the loading indicator vertically
                alignItems: 'center', // Centers the loading indicator horizontally
                zIndex: 999, // Ensures the div is on top of other elements
            }}
        >
            <Circles
                height={40}
                width={40}
                color="#4fa94d"
                ariaLabel="circles-loading"
                wrapperStyle={{}}
                wrapperClass=""
                visible={true}
            />
        </div>;
    }

    const imageUrls = (url) => {
        if (url == null) {
            return '';
        } else {
            let imagepath = url.replace(/\\/g, "\\\\");
            let imageurl = `${URI.SERVER?._COURSE_URL}/${imagepath}`;
            return imageurl;
        }

    }

    return (
        <Fragment>
            {/* Course Item */}
            {
                currentCourseState.slice(pagesVisited, pagesVisited + usersPerPage).map((data, i) => (
                    <Col md="12" key={i}>
                        <div className="course-item d-flex">
                            <div className="course-image-box">
                                <div className="course-image" style={{ height: "230px", width: "290px", backgroundImage: `url(${data ? imageUrls(data.courseDetails.imageUrl) : null})` }}>
                                    {data.instructor?.filter(d =>
                                        data.instructor.length === 1 ||
                                        (data.instructor.length > 1 && d.courseOwner === 1)
                                    ).map((d) => (
                                        <div key={d.learnerUsername} className="author-img d-flex">
                                            <div className="img">
                                                <img
                                                    src={`${um_api}public/getprofilepic/${d.learnerUsername}`}
                                                    alt={`${d.firstName}'s profile`}
                                                />
                                            </div>
                                            <div className="title">
                                                <span>{d.title}</span>
                                                <span className='px-1'>{d.firstName}</span>
                                                <span>{d.lastName}</span>
                                            </div>
                                        </div>
                                    ))}
                                    {/* {data.instructor?.map((d) => (
                                        <div className="author-img d-flex">
                                            <div className="img">
                                                <img src={um_api + `getprofilepic/${d.learnerUsername}`} alt="" />
                                            </div>
                                            <div className="title">
                                                <p>{d.firstName}</p>
                                               
                                            </div>
                                        </div>
                                    ))} */}
                                    <div className="course-price">
                                        <p>{fee_validator(data.courseDetails?.courseFee, data.courseDetails?.courseType, data.courseDetails?.courseForeignFees)}</p>
                                    </div>
                                </div>
                            </div>
                            <div className="course-content">
                                <h6 className="heading">{data.courseDetails.status == "D" ? <Link onClick={() => swal(t('msg'), t('course_disable_trysometime'), "warning")}>{data.courseDetails.courseName}</Link> :
                                    <Link onClick={() => CourseDetails(data.id.courseId, data.id.tenantId, data.courseDetails.status)}>{data.courseDetails.courseName}</Link>}
                                </h6>
                                <div className="rating">
                                    <ul className="list-unstyled list-inline">
                                        {
                                            getAvgRating.length > 0 && (
                                                <Rating
                                                    readonly
                                                    initialValue={getAvgRating[0].avgScore}
                                                    size={25}
                                                />
                                            )
                                        }
                                    </ul>
                                </div>
                                <p className="desc" style={{ textAlign: "justify", textOverflow: "ellipsis", width: "300px", whiteSpace: "nowrap", overflow: "hidden" }} dangerouslySetInnerHTML={{ __html: data.courseDetails.courseDescription }}></p>
                                {data.courseDetails.status == "D" ? <Link className="details-btn" onClick={() => swal(t('msg'), t('course_disable_trysometime'), "warning")}>{t('view_details')}</Link> :
                                    <Link className="details-btn" onClick={() => CourseDetails(data.id.courseId, data.id.tenantId)}>{t('view_details')}</Link>}
                            </div>
                        </div>
                    </Col>
                ))
            }

            <Col md="12" className="text-center">
                <ReactPaginate
                    previousLabel={"Previous"}
                    nextLabel={"Next"}
                    pageCount={pageCount}
                    onPageChange={changePage}
                    containerClassName={"paginationBttns"}
                    previousLinkClassName={"previousBttn"}
                    nextLinkClassName={"nextBttn"}
                    disabledClassName={"paginationDisabled"}
                    activeClassName={"paginationActive"}
                />
            </Col>

        </Fragment>
    );
}

export default UserEnrolledCoursesList;